// src/api/hooks/useNotification.ts

import axios from "axios";
import { API_BASE_PATH } from "../../environment";
import { toast } from "react-toastify";

const NOTIFICATION_BASE_URL = API_BASE_PATH;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

export interface Notification {
  id: number;
  employee_id: string;
  title: string;
  message: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export const getNotificationsByEmployeeId = async (
  employeeId: string,
  token: string | null
): Promise<Notification[]> => {
  try {
    const response = await axios.get<Notification[]>(
      `${NOTIFICATION_BASE_URL}/notifications/${employeeId}`,
      {
        headers: {
          accept: "application/json",
          authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    return [];
  }
};

export const updateNotificationStatus = async (
  id: number,
  employeeId: string,
  status_: string,
  token: string | null
) => {
  try {
    const response = await axios.put(
      `${NOTIFICATION_BASE_URL}/notifications/update-status/${id}/${employeeId}`,
      new URLSearchParams({ status_ }).toString(),
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};

export const deleteNotification = async (
  id: number,
  employeeId: string,
  token: string | null
) => {
  try {
    const response = await axios.delete(
      `${NOTIFICATION_BASE_URL}/notifications/${id}/${employeeId}`,
      {
        headers: {
          accept: "application/json",
          authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    toast.success("Notification deleted");
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw error;
  }
};
